



















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { formatCurrency } from "@/shared/currency";
import { expenseCategoryIcon } from "@/shared/awesomeIconMapper";
import { ExpenseCategory } from "@/shared/types";
import _ from "lodash";

@Component
export default class ExpenseCategoryWidgetRow extends Vue {
  formatCurrency = formatCurrency;
  expenseCategoryIcon = expenseCategoryIcon;

  @Prop({required: false})
  amount: number;

  @Prop({required: false})
  icon: string;

  @Prop({required: false})
  expenseCategory: ExpenseCategory;

  @Prop({required: false})
  index: number;

  @Prop({required: true})
  isSummary: boolean;

  @Prop({required: true})
  total: number;

  get alternate () { return (this.index % 2) === 1; }
  get displayAmount () { return this.isSummary ? this.total : this.amount; }
  get label () { return this.isSummary ? "Total" : _.capitalize(this.icon); }
  get showIcon () { return this.isSummary === false; }
  get widthPercent () { return this.isSummary ? 0 : Math.floor((this.amount / this.total) * 100); }

  get tabletAmount () {
    if (this.displayAmount < 1000) {
      return formatCurrency(this.displayAmount, 0);
    }

    if (this.displayAmount < 10000) {
      return formatCurrency(this.displayAmount / 1000, 1) + "k";
    }

    return formatCurrency(this.displayAmount / 1000, 0) + "k";
  }
}

